import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=0bb5e56c&"
import script from "./BreadCrumb.vue?vue&type=script&lang=js&"
export * from "./BreadCrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb5e56c')) {
      api.createRecord('0bb5e56c', component.options)
    } else {
      api.reload('0bb5e56c', component.options)
    }
    module.hot.accept("./BreadCrumb.vue?vue&type=template&id=0bb5e56c&", function () {
      api.rerender('0bb5e56c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/BreadCrumb.vue"
export default component.exports